// import {post} from '@/util/utils';
import axios from 'axios';
// function fetchLayoutData(id) {
// 	return get('index.php?s=/designer/info.html&id=' + id);
// }




function fetchLayoutData(id) {
	var data={
		"appKey": "31f3fd104bb77c10",
		"sign": "ZmNiMzBjOGVkNWZiZWI0ODRlYzc0NzkwMGIwZmZhNzMxN2RlOWU5YmNmMDc2MzRiMDI2ODIyNzAxMDA1ODc2Nw==",
		"worksheetId": 'layoutkb',
		"rowId": id,
		"getSystemControl":false,
	}
	var headers = {
		'Content-Type': 'application/json'
	}
	var response=axios.post('/api/v2/open/worksheet/getRowByIdPost',data,{headers})

	return response;
}

function saveLayoutData(id, title, raw) {
	var data={
		"appKey": "31f3fd104bb77c10",
		"sign": "ZmNiMzBjOGVkNWZiZWI0ODRlYzc0NzkwMGIwZmZhNzMxN2RlOWU5YmNmMDc2MzRiMDI2ODIyNzAxMDA1ODc2Nw==",
		"worksheetId": 'layoutkb',
		"rowId": id,
		"getSystemControl":false,
		"controls":[
			{
			"controlId":"workshop",
			"value":title
			},{
				"controlId":"raw",
				"value":raw
				}]
	}
	var headers = {
		'Content-Type': 'application/json'
	}
	return axios.post('/api/v2/open/worksheet/editRow',data,{headers});
}

export {fetchLayoutData, saveLayoutData};
